// extracted by mini-css-extract-plugin
export default {"AvatarTag":"AvatarTag_AvatarTag__MFoo1","Avatar":"AvatarTag_Avatar__JyqYv","Name":"AvatarTag_Name__E61aE"};